module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-dialog', {
    staticClass: "store-dialog",
    attrs: {
      "title": "选择店铺",
      "visible": _vm.showDialog,
      "close-on-click-modal": false,
      "before-close": _vm.cancelAction
    },
    on: {
      "update:visible": function($event) {
        _vm.showDialog = $event
      }
    }
  }, [_c('div', {
    staticStyle: {
      "margin-bottom": "15px"
    }
  }, [_c('el-row', {
    attrs: {
      "gutter": 10
    }
  }, [_c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "店铺标签"
    },
    on: {
      "change": _vm.tag_search
    },
    model: {
      value: (_vm.value),
      callback: function($$v) {
        _vm.value = $$v
      },
      expression: "value"
    }
  }, _vm._l((_vm.distributor_tags), function(item) {
    return _c('el-option', {
      key: item.tag_id,
      attrs: {
        "label": item.tag_name,
        "value": item.tag_id
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('el-cascader', {
    attrs: {
      "placeholder": "所属大区",
      "options": _vm.new_office_area,
      "props": {
        checkStrictly: true
      },
      "clearable": ""
    },
    on: {
      "change": _vm.handleOfficeChange
    },
    model: {
      value: (_vm.selected_office_area_id),
      callback: function($$v) {
        _vm.selected_office_area_id = $$v
      },
      expression: "selected_office_area_id"
    }
  })], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "输入店铺英科ID",
      "clearable": ""
    },
    model: {
      value: (_vm.number),
      callback: function($$v) {
        _vm.number = $$v
      },
      expression: "number"
    }
  }, [_c('el-button', {
    attrs: {
      "slot": "append",
      "icon": "el-icon-search"
    },
    on: {
      "click": _vm.handleIconClick
    },
    slot: "append"
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "输入店铺名称",
      "clearable": ""
    },
    model: {
      value: (_vm.name),
      callback: function($$v) {
        _vm.name = $$v
      },
      expression: "name"
    }
  }, [_c('el-button', {
    attrs: {
      "slot": "append",
      "icon": "el-icon-search"
    },
    on: {
      "click": _vm.handleIconClick
    },
    slot: "append"
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    ref: "multipleTable",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.storeData,
      "tooltip-effect": "dark",
      "row-key": _vm.getRowKeys
    },
    on: {
      "selection-change": _vm.handleSelectionChange
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "selection",
      "reserve-selection": true,
      "width": "50"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "name",
      "label": "店铺名称"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "number",
      "label": "店铺英科ID"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "contact",
      "label": "联系人"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "store_name",
      "label": "门店"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "address",
      "label": "地址",
      "show-overflow-tooltip": ""
    }
  })], 1), _vm._v(" "), (_vm.total_count > _vm.params.pageSize) ? _c('div', {
    staticClass: "tr"
  }, [_c('el-pagination', {
    attrs: {
      "layout": "prev, pager, next",
      "total": _vm.total_count,
      "page-size": _vm.pageLimit
    },
    on: {
      "current-change": _vm.handleCurrentChange
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": _vm.cancelAction
    }
  }, [_vm._v("取 消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.saveStoreAction
    }
  }, [_vm._v("确 定")])], 1)], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-24d06cee", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-24d06cee"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/function/distributorSelect.vue
// module id = 2544
// module chunks = 0